import { Component } from "react";
import withRouter from "../../utils/withRouter";
import { BiChevronLeft } from "react-icons/bi";

class OrderDetails extends Component {
    render(){
        return <div className="p-5 font-Neurial">
                <div className="flex flex-col gap-5 mb-16">
                    <div className="flex items-center gap-3">
                        <BiChevronLeft className="text-[#070E05] text-[25px] cursor-pointer" onClick={e=>{
                                const { navigate } = this.props;
                                navigate(`/customers/`);
                        }} />
                        <div className="font-bold text-[20px] text-[#070E05]">Order Details</div>
                    </div>
                    <div className="w-full flex flex-col gap-4">
                        <div className="flex gap-4">
                            <div className="w-2/3 bg-white p-5 rounded-lg space-y-4">
                                <div className="font-bold text-[17px]">Order ID <span className="text-[#2121F1]">#342894</span></div>
                                <div className="table-container w-full">
                                    <table className='table-auto w-full border-collapse border-[1px] border-[#E8E8E8]'>
                                        <thead className="bg-[#F7F7F7] rounded-[8px] text-[14px] text-[#787389] font-medium" style={{
                                            position: "sticky",
                                            top: "0",
                                        }}>
                                            <tr className="">
                                                <th className="py-1 px-2 text-start">Item Summary</th>
                                                <th className="py-1 px-2 text-start">Qty.</th>
                                                <th className="py-1 px-2 text-start">Price</th>
                                                <th className="py-1 px-2 text-start">Total Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Array.from({length: 3}, (_, i)=> {
                                                return {
                                                    name: "Wool Sweater",
                                                    trackId: "#874640",
                                                    category: "Sweatshirt",
                                                    price: "N 23,000",
                                                    qty: 15,
                                                    amount: "N 345,000"
                                                }
                                            }).map((v, k)=>{
                                                    return <tr className="text-[#787389] text-[15px]" key={k}>
                                                        <td className="py-1 px-3 border-b-[1px] font-normal"><div className="inline-flex items-center gap-3"><div className="h-[35px] w-[35px] rounded-[3px] bg-black"></div>{v.name}</div></td>
                                                        <td className="py-1 px-3 border-b-[1px]">{v.qty}</td>
                                                        <td className="py-1 px-3 border-b-[1px]">{v.price}</td>
                                                        <td className="py-1 px-3 border-b-[1px]">{v.amount}</td>
                                                </tr>
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                </div>
                            <div className="w-1/3 bg-white p-5 rounded-lg">
                                <div className="flex flex-col gap-6">
                                    <div className="flex justify-between items-center">
                                        <div className="font-bold text-[17px]">Order summary</div>
                                        <div className="flex items-center gap-2 text-[13px] text-[#27AE60]"><i className="w-[9px] h-[9px] bg-[#27AE60] rounded-full"/><span>Completed</span></div>
                                    </div>
                                    <div className="flex justify-between items-center text-[14px]">
                                        <div className="text-[#828282] font-bold">Order Created</div>
                                        <div className="text-[#4F4F4F] font-bold">20 August, 2022</div>
                                    </div>
                                    <div className="flex justify-between items-center text-[14px]">
                                        <div className="text-[#828282] font-bold">Order Time</div>
                                        <div className="text-[#4F4F4F] font-bold">9:41 AM</div>
                                    </div>
                                    <div className="flex justify-between items-center text-[14px]">
                                        <div className="text-[#828282] font-bold">Subtotal</div>
                                        <div className="text-[#4F4F4F] font-bold">N 207,000</div>
                                    </div>
                                    <div className="flex justify-between items-center text-[14px]">
                                        <div className="text-[#828282] font-bold">Delivery Fee</div>
                                        <div className="text-[#4F4F4F] font-bold">N 4,500</div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="flex gap-4">
                            <div className="w-2/3 flex flex-col gap-4">
                                <div className="bg-white p-5 rounded-lg flex flex-col gap-6">
                                    <div className="flex justify-between items-center">
                                        <div className="font-bold text-[17px]">Customer Details</div>
                                    </div>
                                    <div className="flex justify-between items-center text-[14px]">
                                        <div className="text-[#828282] font-bold">Customer Name</div>
                                        <div className="text-[#4F4F4F] font-bold">Darrell Steward</div>
                                    </div>
                                    <div className="flex justify-between items-center text-[14px]">
                                        <div className="text-[#828282] font-bold">Email</div>
                                        <div className="text-[#4F4F4F] font-bold">willie.jennings@example.com</div>
                                    </div>
                                    <div className="flex justify-between items-center text-[14px]">
                                        <div className="text-[#828282] font-bold">Phone Number</div>
                                        <div className="text-[#4F4F4F] font-bold">08026172881</div>
                                    </div>
                                </div>
                                <div className="bg-white p-5 rounded-lg flex flex-col gap-3">
                                    <div className="font-bold text-[17px]">Merchants</div>
                                    <div className="flex gap-2 items-center">
                                        <div className="w-[32px] h-[32px] rounded-full bg-dark"></div>
                                        <div className="text-[18px] tracking-[-0.5px] text-[#181819E5]">Fashion</div>
                                    </div>
                                </div>
                            </div>
                            <div className="w-1/3 flex flex-col gap-4">
                                <div className="bg-white p-5 rounded-lg">
                                    <div className="flex justify-between items-center text-[14px]">
                                        <div className="text-[#828282] font-bold">Total</div>
                                        <div className="text-[#4F4F4F] font-bold">N 287,000</div>
                                    </div>
                                </div>
                                <div className="bg-white p-5 rounded-lg flex flex-col gap-6">
                                    <div className="flex justify-between items-center">
                                        <div className="font-bold text-[17px]">Delivery Address</div>
                                    </div>
                                    <div className="flex justify-between items-center text-[14px]">
                                        <div className="text-[#828282] font-bold">Address</div>
                                        <div className="text-[#4F4F4F] font-bold">3891 Ranchview Dr. Richardson, </div>
                                    </div>
                                    <div className="flex justify-between items-center text-[14px]">
                                        <div className="text-[#828282] font-bold">State</div>
                                        <div className="text-[#4F4F4F] font-bold">Lagos</div>
                                    </div>
                                    <div className="flex justify-between items-center text-[14px]">
                                        <div className="text-[#828282] font-bold">Zipcode</div>
                                        <div className="text-[#4F4F4F] font-bold">100278</div>
                                    </div>
                                    <div className="flex justify-between items-center text-[14px]">
                                        <div className="text-[#828282] font-bold">Country</div>
                                        <div className="text-[#4F4F4F] font-bold">Nigeria</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
    }
}


export default withRouter(OrderDetails);